import React, { forwardRef } from "react";
import hoistReactStatics from "hoist-non-react-statics";
import BridgeV2 from "@akulaku/web-bridge";
import get from "lodash/get";
import performanceCollection from "@al/performance-collect";

const isAndroid = () => {
  return process.browser && /(Android)/i.test(window.navigator.userAgent);
};

export default function withPerfCollect(options) {
  return (WrappedComponent) => {
    const name = WrappedComponent.displayName || WrappedComponent.name;

    class WithPerfCollect extends React.Component {
      constructor(props, ...rest) {
        super(props, ...rest);
        if (process.browser) {
          BridgeV2.getEnvInfoSilent("", (res) => {
            // eslint-disable-next-line
            console.log(res, "getEnvInfoSilent response");
            const deviceLevel = get(res, "data.deviceLevel");
            performanceCollection.setDeviceLevel(`${isAndroid() ? "android" : "ios"}_${deviceLevel || "unknown"}`);
          });
        }
      }

      componentDidMount() {
        const { criticalAPI } = options;
        let api = criticalAPI;
        if (criticalAPI && typeof criticalAPI === "function") {
          api = criticalAPI(this.props);
        }

        performanceCollection.recordPagePerformance({
          isFirstPage: true,
          ...options,
          criticalAPI: api,
        });
      }

      render() {
        const { forwardedRef, ...props } = this.props;
        return <WrappedComponent {...props} ref={forwardedRef} />;
      }
    }

    const refForwardedComponent = forwardRef((props, ref) => <WithPerfCollect {...props} forwardedRef={ref} />);
    refForwardedComponent.displayName = `forwardRef(${name})`;

    hoistReactStatics(refForwardedComponent, WrappedComponent);

    return refForwardedComponent;
  };
}
